/*
 * Copyright (c) 2019
 *    Reliant Business Valuation, LLC - http://reliantvalue.com
 *    Author: Ronnel Bedana - ronnel@internalvaluation.com
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
import { Injectable } from '@angular/core';
import { HttpErrorResponse } from '@angular/common/http';
import { CrmError, ErrorType } from '../model/error';
import { UserService } from './user.service';
import { User } from '../model';

@Injectable({
  providedIn: 'root'
})
export class ErrorService {

  constructor(private userService: UserService) {}
  getClientMessage(error: Error): CrmError {
    if (!navigator.onLine) {
      return {
        HASH: this.getHash(error.message),
        TYPE: ErrorType.APP_ERROR,
        DATE: new Date(),
        USER: User.parse(this.userService.getCurrentUser()),
        MESSAGE: 'No Internet Connection'
      };
    }
    return  {
      HASH: this.getHash(error.message ? error.message : error.toString()),
      TYPE: ErrorType.APP_ERROR,
      DATE: new Date(),
      USER: User.parse(this.userService.getCurrentUser()),
      MESSAGE: error.message ? error.message : error.toString(),
      STACK: error.stack ? error.stack : ''
    };

  }

  getClientStack(error: Error): string {
    return error.stack;
  }

  getServerMessage(error: HttpErrorResponse): CrmError {
    return {
      HASH: this.getHash(error.message),
      TYPE: ErrorType.HTTP_ERROR,
      DATE: new Date(),
      USER: User.parse(this.userService.getCurrentUser()),
      CODE: error.status,
      MESSAGE: error.message
    };
  }

  getServerStack(error: HttpErrorResponse): string {
    // handle stack trace
    return 'stack';
  }

  getHash(str: string): number {
    let hash = 0;
    for (let i = 0; i < str.length; i++) {
      hash = ~~(((hash << 5) - hash) + str.charCodeAt(i));
    }
    return hash;
  }
}
